import React from "react";
import EstimationFraisNotaire from "../components/EstimationFraisNotaire";

export default function EstimationFraisNotairePage() {
  return <EstimationFraisNotaire />;
}
